import { isMobile } from 'is-mobile'

const isIe = (): Boolean => {
  const ua = navigator.userAgent;
  return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
}

export const isWebglSupport = (): Boolean => {
  const canvas = document.createElement("canvas");
  const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

  return Boolean(!isIe() && gl && gl instanceof WebGLRenderingContext);
};

export const checkLandScape = (): Boolean => isMobile() ? Boolean(window.orientation) : true

export const bindLandCheck = (cb: Function): void => 
  window.addEventListener('orientationchange', () =>  
    cb(checkLandScape())
  )
